<template>
  <Modal
    class="cc-modal"
    width="600"
    footer-hide
    v-model="visibility"
    title="添加发票信息"
  >
    <div class="content">
      <loading class="fixed" :loading="loading" style="z-index: 11"></loading>
      <div class="section">
        <div class="col">
          <div class="name">开具类型：</div>
          <RadioGroup v-model="form.issuingType">
            <Radio :label="0" :disabled="type == 2">个人</Radio>
            <Radio :label="1" :disabled="type == 2">企业</Radio>
          </RadioGroup>
        </div>
        <div class="col">
          <div class="name">发票类型：</div>
          <RadioGroup v-model="form.invoiceType">
            <Radio :label="0" :disabled="type == 2">增值税普通发票</Radio>
            <Radio :label="1" :disabled="type == 2">增值税专用发票</Radio>
          </RadioGroup>
        </div>
        <div class="col">
          <div class="name">发票抬头：</div>
          <Input
            class="height45"
            v-model="form.header"
            placeholder="请输入发票抬头"
            style="width: 300px"
            clearable
          />
        </div>
        <template v-if="form.issuingType === 1 || form.invoiceType === 1">
          <div class="col">
            <div class="name">税务登记号：</div>
            <Input
              class="height45"
              v-model="form.taxId"
              placeholder="请输入发票抬头"
              style="width: 300px"
              clearable
            />
          </div>
        </template>
        <template v-if="form.invoiceType === 1">
          <div class="col">
            <div class="name">开户行：</div>
            <Input
              class="height45"
              v-model="form.bankName"
              placeholder="请输入开户行"
              style="width: 300px"
              clearable
            />
          </div>
          <div class="col">
            <div class="name">开户账户：</div>
            <Input
              class="height45"
              v-model="form.bankCard"
              placeholder="请输入开户账户"
              style="width: 300px"
              clearable
            />
          </div>
          <div class="col">
            <div class="name">注册地址：</div>
            <Input
              class="height45"
              v-model="form.address"
              placeholder="请输入注册地址"
              style="width: 300px"
              clearable
            />
          </div>
          <div class="col">
            <div class="name">联系电话：</div>
            <Input
              class="height45"
              v-model="form.mobile"
              placeholder="请输入联系电话"
              style="width: 300px"
              clearable
            />
          </div>
          <div class="col">
            <div class="name">一般纳税人资质证明：</div>
            <Upload
              v-if="!form.certificateFilePath"
              style="width: 200px"
              type="drag"
              :before-upload="($event) => handleBeforeUpload($event, 1)"
              :show-upload-list="false"
              action="/"
            >
              <div class="upload-section">
                <img class="icon" src="@/assets/image/upload-icon.png" />
              </div>
            </Upload>
            <div
              class="icon2"
              :style="{
                backgroundImage: 'url(' + form.certificateFilePath + ')',
              }"
              v-else
            >
              <div class="close" @click="delImage(1)">
                <Icon size="28" type="ios-close-circle-outline" />
              </div>
            </div>
          </div>
          <div class="col">
            <div class="name">税务登记证复印件：</div>
            <Upload
              v-if="!form.taxFilePath"
              style="width: 200px"
              type="drag"
              :before-upload="($event) => handleBeforeUpload($event, 2)"
              :show-upload-list="false"
              action="/"
            >
              <div class="upload-section">
                <img class="icon" src="@/assets/image/upload-icon.png" />
              </div>
            </Upload>
            <div
              class="icon2"
              :style="{ backgroundImage: 'url(' + form.taxFilePath + ')' }"
              v-else
            >
              <div class="close" @click="delImage(2)">
                <Icon size="28" type="ios-close-circle-outline" />
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="foot">
      <Button
        :loading="loading"
        @click="onConfirm"
        type="primary"
        style="margin-right: 20px"
        >确定</Button
      >
      <Button @click="onCancel">取消</Button>
    </div>
  </Modal>
</template>
<script>
import { invoiceInfoSave, invoiceInfoDetail } from "api/user.js";
import loading from "components/loading.vue";
export default {
  name: "addInvoiceModal",
  components: {
    loading,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    type: {
      type: [String, Number],
      default: 1, // 1:create 2:update
    },
    id: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      form: {
        issuingType: 0,
        invoiceType: 0,
        header: "",
        taxId: "",
        mobile: "",
        address: "",
        bankCard: "",
        bankName: "",
        certificateFile: "",
        certificateFilePath: "",
        taxFile: "",
        taxFilePath: "",
      },
      loading: false,
    };
  },
  computed: {
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  watch: {
    show: {
      handler(val) {
        if (val) {
          this.req_invoiceInfoDetail();
        }
      },
    },
  },
  methods: {
    // 取消
    onCancel() {
      this.form = this.$options.data().form;
      this.visibility = false;
    },
    // 确认
    async onConfirm() {
      if (!this.form.header) {
        this.$Message.warning("请输入发票抬头！");
        return;
      }
      if (this.form.issuingType === 1 || this.form.invoiceType === 1) {
        if (!this.form.taxId) {
          this.$Message.warning("请输入税务登记号！");
          return;
        }
      }
      if (this.form.invoiceType === 1) {
        if (!this.form.bankName) {
          this.$Message.warning("请输入开户行！");
          return;
        }
        if (!this.form.bankCard) {
          this.$Message.warning("请输入开户账户！");
          return;
        }
        if (!this.form.address) {
          this.$Message.warning("请输入注册地址！");
          return;
        }
        if (!this.form.mobile) {
          this.$Message.warning("请输入联系电话！");
          return;
        }
        if (!this.form.certificateFile) {
          this.$Message.warning("请上传一般纳税人资质证明！");
          return;
        }
        if (!this.form.taxFile) {
          this.$Message.warning("请上传税务登记证复印件！");
          return;
        }
      }
      this.loading = true;
      try {
        const data = new FormData();
        data.append("issuingType", this.form.issuingType);
        data.append("invoiceType", this.form.invoiceType);
        data.append("header", this.form.header);
        if (this.form.issuingType === 1 || this.form.invoiceType === 1)
          data.append("taxId", this.form.taxId);
        if (this.form.invoiceType === 1) {
          data.append("bankName", this.form.bankName);
          data.append("bankCard", this.form.bankCard);
          data.append("address", this.form.address);
          data.append("mobile", this.form.mobile);
          if (this.form.certificateFile)
            data.append("certificateFile", this.form.certificateFile);
          if (this.form.taxFile) data.append("taxFile", this.form.taxFile);
        }
        if (this.type === 2) {
          data.append("id", this.id);
        }
        const res = await invoiceInfoSave(data);
        this.loading = false;
        if (res.code === 200 && res.result) {
          this.$emit("submit-success", (res) => {
            if (res) {
              this.onCancel();
              this.$Message.success("提交成功！");
            }
          });
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    async req_invoiceInfoDetail() {
      try {
        this.loading = true;
        const { code, data, result } = await invoiceInfoDetail({ id: this.id });
        this.loading = false;
        if (code === 200 && result) {
          this.form.issuingType = data.issueType;
          this.form.invoiceType = data.invoiceType;
          this.form.header = data.title;
          this.form.taxId = data.taxId;
          this.form.mobile = data.mobile;
          this.form.address = data.registeredAddress;
          this.form.bankCard = data.bankAccountNumber;
          this.form.bankName = data.initialBank;
          this.form.certificateFile = data.taxpayerEvidence;
          this.form.certificateFilePath = data.taxpayerEvidence;
          this.form.taxFile = data.taxImg;
          this.form.taxFilePath = data.taxImg;
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    // 选择图片后处理
    handleBeforeUpload(file, type = 1) {
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/png" &&
        file.type !== "image/jpg"
      ) {
        this.$Message.warning("图片要求上传jpg或者png格式或者jpeg格式");
        return false;
      }
      if (type === 1) {
        this.form.certificateFile = file;
        this.form.certificateFilePath = window.URL.createObjectURL(file);
      } else {
        this.form.taxFile = file;
        this.form.taxFilePath = window.URL.createObjectURL(file);
      }

      return false;
    },
    // 删除图片
    delImage(type = 1) {
      if (type === 1) {
        this.form.certificateFile = "";
        this.form.certificateFilePath = "";
      } else {
        this.form.taxFilePath = "";
        this.form.taxFile = "";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.cc-modal {
  .content {
    // height: auto;
    min-height: 100px;
    max-height: 500px;
    overflow: auto;
  }
  .foot {
    border-top: 1px solid #dcdee2;
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
.col {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 20px;
  .name {
    color: #333333;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .label {
    color: #999999;
  }
}
.upload-section {
  width: 200px;
  height: 122px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .icon {
    width: 45px;
    height: 35px;
  }
}
.icon2 {
  border: 1px dashed #dcdee2;
  position: relative;
  width: 200px;
  height: 122px;
  background-size: cover;
  background-position: center;
  .close {
    position: absolute;
    right: 5px;
    top: 5px;
    cursor: pointer;
  }
}
.fixed {
  top: 51px;
  bottom: 64px;
  transform: translateX(-50%);
  height: auto;
}
</style>
<style lang="less" scoped>
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
</style>
